import { z } from 'zod';

export type TPageConfiguration = z.infer<typeof pageConfigurationSchema>;

const formPositionSchema = z.enum([
  'Do nothing',
  'Remove Forms',
  'Remove everything',
  'Override',
]);

export type TFormPosition = z.infer<typeof formPositionSchema>;

export const pageConfigurationSchema = z
  .object({
    companiesContainerTitle: z.string().optional().nullable(),
    peopleContainerTitle: z.string().optional().nullable(),
    slug: z.string().optional().nullable(),
    showBasicProfileActionButtons: z.boolean(),
    form: z.string().optional().nullable(),
    position: formPositionSchema,
  })
  .nullable()
  .optional();
